
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VHSGlitchEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const bars = Math.floor(5 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.2 / (layerIndex + 1);
            for (let i = 0; i < bars; i++) {
                const y = ((curTime * 500 + this.pseudoRandom(i) * 5000) % (height * 3)) - height * 1.5;
                const h = (2 + this.pseudoRandom(i) * 10) * scale;
                const offset = Math.sin(curTime * 20 + i) * 50 * scale;
                
                ctx.fillRect(-width * 1.5 + offset, y, width * 3, h);
            }
            
            // Random static bursts
            if (this.pseudoRandom(Math.floor(time * 60)) > 0.95) {
                for (let j = 0; j < 50; j++) {
                    const sx = (this.pseudoRandom(j) - 0.5) * width * 3;
                    const sy = (this.pseudoRandom(j + 1) - 0.5) * height * 3;
                    ctx.fillRect(sx, sy, 2 * scale, 2 * scale);
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
